import * as React from 'react';
import { connect } from 'react-redux';
import { UserInfo } from '../Login/common/defaults';
import { clear } from './redux-objects/actions';
import * as urls from '../shared/urls';
import { IComment, IReport } from '../../common/sharedTypes';
import { Button, OverlayTrigger, Popover, Row, Col } from 'react-bootstrap';
import CorrespondenceView from './CorrespondenceView';
import '@fortawesome/fontawesome-free/css/all.css';
import 'font-awesome/css/font-awesome.css';
import './assets/correspondence.scss';
const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

export interface ICorrespondenceButtonProps {
  currentUser: UserInfo;
  reportId: number;
  reportCorrespondence: IComment[];
  className?: string;
  report?: IReport;
  clear?: () => Promise<void>;
}
export interface ICorrespondenceButtonState {
  showCorrespondence: boolean;
}
const initialState: ICorrespondenceButtonState = {
  showCorrespondence: false,
};
class CorrespondenceButton extends React.Component<
  ICorrespondenceButtonProps,
  ICorrespondenceButtonState
> {
  windowRef: any;

  public constructor(props: ICorrespondenceButtonProps) {
    super(props);
    this.state = initialState;
  }
  onShowCorrespondence = () => {
    this.setState({ showCorrespondence: true });
  };

  closeModal = () => {
    this.setState(
      {
        showCorrespondence: false,
      },
      () => {
        this.props.clear();
      }
    );
  };

  public render() {
    return (
      <React.Fragment>
        <Button
          variant='secondary'
          className={this.props.className}
          onClick={(e) => this.onShowCorrespondence()}
        >
          <i className='fas fa-envelope'></i>
        </Button>
        {this.state.showCorrespondence && (
          <CorrespondenceView
            reportId={this.props.reportId}
            onCloseModal={this.closeModal}
          />
        )}
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    reportCorrespondence: state.Correspondence.reportCorrespondence,
    report: state.Correspondence.report,
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {
  clear,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CorrespondenceButton);
